import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import Reports from "@/pages/Reports";
import MasterData from "@/pages/MasterData";
import Users from "@/pages/Users";
import Periods from "@/pages/Periods";
import AuditTrail from "@/pages/AuditTrail";
import Payroll from "@/pages/Payroll";
import FixedAssets from "@/pages/FixedAssets";
import Arsip from "@/pages/Arsip";
import Jurnal from "@/pages/Jurnal";
import Invoices from "@/pages/Invoices";
import ManageData from "@/pages/ManageData";
import AiAssistant from "@/pages/AiAssistant";
import Receivables from "@/pages/Receivables";
import ClientWorkspace from "@/pages/ClientWorkspace";
import ProjectTracker from "@/pages/ProjectTracker";
import Documents from "@/pages/Documents";
import FakturPajak from "@/pages/FakturPajak";
import { Loader2 } from "lucide-react";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

const INTERNAL = ["super_admin", "staff_keuangan", "staff_pajak", "supervisor", "leader"];

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/transaksi" element={<Protected><Transactions /></Protected>} />
      <Route path="/laporan" element={<Protected><Reports /></Protected>} />
      <Route path="/payroll" element={<Protected><Payroll /></Protected>} />
      <Route path="/aset" element={<Protected><FixedAssets /></Protected>} />
      <Route path="/master" element={<Protected><MasterData /></Protected>} />
      <Route path="/jurnal" element={<Protected roles={INTERNAL}><Jurnal /></Protected>} />
      <Route path="/invoice" element={<Protected><Invoices /></Protected>} />
      <Route path="/data" element={<Protected><ManageData /></Protected>} />
      <Route path="/piutang" element={<Protected><Receivables /></Protected>} />
      <Route path="/ai" element={<Protected><AiAssistant /></Protected>} />
      <Route path="/klien" element={<Protected roles={INTERNAL}><ClientWorkspace /></Protected>} />
      <Route path="/proyek" element={<Protected roles={INTERNAL}><ProjectTracker /></Protected>} />
      <Route path="/dokumen" element={<Protected><Documents /></Protected>} />
      <Route path="/faktur" element={<Protected><FakturPajak /></Protected>} />
      <Route path="/arsip" element={<Protected><Arsip /></Protected>} />
      <Route path="/periode" element={<Protected roles={["super_admin", "supervisor"]}><Periods /></Protected>} />
      <Route path="/pengguna" element={<Protected roles={["super_admin"]}><Users /></Protected>} />
      <Route path="/audit" element={<Protected roles={INTERNAL}><AuditTrail /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
